module.exports = __webpack_public_path__ + "img/cancel.81fca42d.svg";